
let baseURL;

baseURL = 'https://qa-publicparkingapp.appinsnap.com/api/';
export { baseURL };
